import { fetchBusiness } from './api';

export interface BusinessInfo {
  name: string;
}

// Mirror of services/businessLogo.ts — module-level cache so the ticket
// modal doesn't briefly render "HalloChef" (or an empty string) before
// the real business name comes back on every open.

let cached: Promise<BusinessInfo | null> | undefined;
let current: BusinessInfo | null = null;

async function load(): Promise<BusinessInfo | null> {
  try {
    const res = await fetchBusiness();
    current = res.data && res.data.length > 0 ? { name: res.data[0].name } : null;
    return current;
  } catch (err) {
    cached = undefined;
    throw err;
  }
}

export function getBusinessInfo(): Promise<BusinessInfo | null> {
  if (cached === undefined) cached = load();
  return cached;
}

// Sync read for components that want to avoid a render-then-update flash
// on mount; returns null until the prime fetch finishes.
export function getBusinessInfoSync(): BusinessInfo | null {
  return current;
}

export function invalidateBusinessInfo(): void {
  cached = undefined;
  current = null;
}
